import styled from 'styled-components'

export const StyledBrand = styled.div`
  /* TO BE DONE */
`

export const StyledBrandBanner = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 140px 0;

  p {
    margin: 0;
    margin-top: 55px;
    font-size: 32px;
    line-height: 42px;
    color: #21213e;
  }

  a.button {
    height: 45px;
    background: ${({ theme }) => theme.colors.primary};
    border: 2px solid rgba(126, 117, 187, 0.2);
    border-radius: 22.5px;
    line-height: 41px;
    padding: 0 40px;
    font-size: 17px;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
    margin-top: 50px;
  }

  @media screen and (max-width: 620px) {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 100px;

    img {
      position: relative;
      top: -2px;
      width: 100%;
    }
    p {
      padding: 0 30px;
      font-size: 28px;
      line-height: 42px;
      text-align: center;
    }
  }
`

export const StyledBrandAssets = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-bottom: 140px;
`

export const StyledBrandAssetItem = styled.div`
  display: flex;
  flex-flow: row nowrap;

  .with-logo,
  .with-content {
    width: 584px;
    height: 425px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    padding: 80px;
  }
  .with-content {
    align-items: flex-start;

    .title {
      font-size: 32px;
      color: #ffffff;
      margin: 0;
    }
    .subtitle {
      font-size: 17px;
      line-height: 32px;
      color: #ffffff;
      margin: 0;
      margin-top: 10px;
      text-align: left;
    }
    a {
      border: 1px solid #ffffff;
      box-sizing: border-box;
      border-radius: 20px;
      color: white;
      line-height: 40px;
      font-size: 17px;
      padding: 0 50px;
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 620px) {
    flex-flow: column nowrap;

    &:nth-last-child(2) {
      flex-direction: column-reverse;
    }

    .with-logo,
    .with-content {
      width: 100%;
      padding: 60px 35px;
      height: unset;
      min-height: 270px;

      .subtitle {
        padding: 0;
      }
      img {
        max-width: 300px;
      }
    }
  }
`
